module.exports = __webpack_public_path__ + "img/szgj.749025a7.svg";